import Box from "@mui/material/Box";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { withTranslation } from "react-i18next";

// old ValidationAccordion.jsx 포팅 — 검증유형(BOM/BOR/Order/Item)별 아코디언 + 하위 세부 검증항목
// 리스트. 세부항목 클릭 시 부모(Validation.js)의 onSelect(models, title)로 우측 modelGrid를 채운다.
// old는 wingui-core의 AccordionComponent + themeStore 커스텀 컬러토큰을 썼으나, new는 이 코드베이스의
// 표준 MUI Accordion 패턴(DP/IP/RP/MP *Settings.js와 동일 계열)으로 대체.
const chipColor = (errorCount) => (errorCount > 0 ? "warning" : "default");

// MUI Accordion은 스택된 항목 사이엔 구분선을 자동으로 그려주지만 맨 마지막 항목 아래에는
// 그려주지 않는다(라이브러리 기본 동작) — 그룹 사이 구분선과 동일한 색으로 하단을 닫아준다.
const ValidationAccordion = ({ t, data, onSelect }) => (
  <Box sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>
    {(data ?? []).map((main) => {
      const { validationType: mainValidationType, errorCount: mainErrorCount, details } = main;
      return (
        <Accordion key={mainValidationType} defaultExpanded>
          {/* DpSettings.js(.content-title/.MuiAccordionSummary-root, DataLoadValidation.scss)와 동일한
              룩앤필 — 옅은 배경 밴드 + 굵은 18px 제목으로 통일. */}
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ backgroundColor: "#f0f5fa", minHeight: 52, "&.Mui-expanded": { minHeight: 52 } }}
          >
            <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>{t(mainValidationType)}</Typography>
            <Chip size="small" sx={{ ml: 1 }} color={chipColor(mainErrorCount)} label={mainErrorCount} />
          </AccordionSummary>
          <AccordionDetails sx={{ p: 0 }}>
            <List sx={{ p: 0 }}>
              {(details ?? []).map((detail, index) => {
                const { validationType, errorCount, models } = detail;
                // 우측 그리드 위 섹션 라벨용 — 제목(검증유형)과 부가정보(세부 항목/건수)를 한 문자열로
                // 붙이지 않고 나눠서 넘긴다(fp-master-screen-guide.md §15-1a).
                const title = { main: t(mainValidationType), detail: `${t(validationType)} ( ${errorCount} )` };
                return (
                  <ListItemButton
                    key={validationType}
                    divider={index !== details.length - 1}
                    onClick={() => onSelect(models, title)}
                  >
                    <ListItemText sx={{ width: "40%" }} primary={t(validationType)} />
                    <Chip size="small" color={chipColor(errorCount)} label={errorCount} />
                  </ListItemButton>
                );
              })}
            </List>
          </AccordionDetails>
        </Accordion>
      );
    })}
  </Box>
);

export default withTranslation()(ValidationAccordion);
